import React from 'react';
import { Card } from './ui/card';
import { trustData } from '../data/mock';
import { Star } from 'lucide-react';

const Trust = ({ onContactClick }) => {
  return (
    <section id="trust" className="py-20 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] text-white relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={trustData.image}
          alt="Professional team"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              {trustData.title}
            </h2>
            <div className="w-24 h-1 bg-white mx-auto mb-6"></div>
            <p className="text-lg text-gray-100 max-w-3xl mx-auto">
              {trustData.subtitle}
            </p>
          </div>

          {/* Achievements */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
            {trustData.achievements.map((achievement, index) => (
              <Card
                key={index}
                className="p-6 text-center bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <div className="text-4xl font-bold text-white mb-2">
                  {achievement.number}
                </div>
                <div className="text-sm text-gray-100">{achievement.label}</div>
              </Card>
            ))}
          </div>

          {/* Reasons */}
          <div className="grid md:grid-cols-2 gap-8">
            {trustData.reasons.map((reason, index) => (
              <Card
                key={index}
                className="p-8 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300"
              >
                <div className="flex gap-4 mb-4">
                  <Star className="w-6 h-6 text-[#2d8b8b] flex-shrink-0 mt-1" fill="currentColor" />
                  <h3 className="text-xl font-bold text-white">
                    {reason.title}
                  </h3>
                </div>
                <p className="text-gray-100 leading-relaxed">
                  {reason.description}
                </p>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;
